import React from "react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { IButton, IButtonProps } from "../IButton";
import { ITooltip } from "../../ITooltip/ITooltip";
import {
  AddButtonIco,
  ButtonAddIco,
  ButtonDeleteIco,
  ButtonDownloadIco,
  ButtonEditIco,
  DownloadIco,
  HistoryIco,
  InfoIco,
  SearchFieldIco,
  VisibleIcon,
  PlusIco,
  ExcelIco,
  DragIco,
  ArrowIco,
  FileCollectionIco,
  BackIco,
  SettingsIco,
  MinusIco,
} from "../../../assets/customIcons";

import styles from "./IconButton.module.scss";
import stylesButton from "../IButton.module.scss";
import Constants from "../../../constants/Common";

const icons = {
  edit: <ButtonEditIco />,
  add: <PlusIco />,
  delete: <ButtonDeleteIco />,
  search: <SearchFieldIco />,
  visible: <VisibleIcon />,
  info: <InfoIco />,
  history: <HistoryIco />,
  download: <ButtonDownloadIco />,
  xls: <ExcelIco />,
  sorting: <DragIco />,
  arrow: <ArrowIco />,
  files: <FileCollectionIco />,
  back: <BackIco />,
  settings: <SettingsIco />,
  minus: <MinusIco />,
};

export type IIconButtonTypeIcon =
  | "edit"
  | "new"
  | "add"
  | "delete"
  | "download"
  | "visible"
  | "search"
  | "info"
  | "history"
  | "xls"
  | "sorting"
  | "arrow"
  | "files"
  | "back"
  | "minus"
  | "settings"; // расширить

export interface IIconButtonProps extends IButtonProps {
  className?: string;
  isDisabled?: boolean;
  children?: React.ReactNode;
  typeIcon?: IIconButtonTypeIcon;
  onClick?: (e: React.MouseEvent) => void;
  to?: string;
}

export const IconButton: React.FC<IIconButtonProps> = ({
  className,
  isDisabled,
  onClick,
  to,
  size,
  variant,
  children,
  typeIcon = "edit",
  title = "",
  ...rest
}) => {
  const { titleIcons } = Constants;
  const classNameString = classnames(
    styles.iconButton,
    styles[size],
    styles[variant],
    className,
    {
      [styles.iconButtonWithText]: children,
      [stylesButton.button]: to,
    },
  );

  const currentTitle = title ? title : titleIcons[typeIcon] ?? "";

  return (
    <ITooltip
      title={currentTitle}
      placement="right"
      overlayStyle={{
        opacity: currentTitle ? "1" : "0",
        visibility: currentTitle ? "visible" : "hidden",
      }}
    >
      {to ? (
        <Link
          to={to}
          disabled={isDisabled}
          className={classNameString}
          {...rest}
        >
          {icons[typeIcon]}
          {children}
        </Link>
      ) : (
        <IButton
          className={classNameString}
          isDisabled={isDisabled}
          onClick={onClick}
          {...rest}
        >
          {icons[typeIcon]}
          {children}
        </IButton>
      )}
    </ITooltip>
  );
};
